export const CLOSE_POPOVER_COOKIE_EXPIRY = 72 * 60 * 60 * 1000;

export const MIN_POPOVER_VIEWS = 1;

export const MAX_POPOVER_VIEWS = 3;
